import { StyleSheet } from 'aphrodite';
import { brandPrimary, gray3, nameCircles } from '../../../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		maxWidth: 1024,
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		marginBottom: 24,
	},
	buttonGroup: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		gap: 12,
		marginTop: 24,
	},
	eventResponseMessage: {
		'@media only screen and (min-width: 768px)': {
			flexDirection: 'row',
			margin: '24px auto 24px',
			maxWidth: 1024,
			padding: 24,
		},
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		marginLeft: 0,
		marginRight: 0,
		marginTop: 24,
		marginBottom: 24,
		padding: 12,
		borderRadius: 3,
	},
	divider: {
		maxWidth: 1024,
		width: '100%',
		borderTop: `2px solid ${nameCircles}`,
	},
	ticketSection: {
		marginTop: 16,
		marginBottom: 16,
	},
	sectionTitle: {
		fontSize: 16,
		fontWeight: 600,
		marginBottom: 12,
		marginTop: 0,
	},
	ticketHolderList: {
		listStyle: 'none',
		padding: 0,
		margin: 0,
	},
	ticketHolder: {
		padding: '8px 0',
		textAlign: 'left',
		borderBottom: `1px solid ${gray3}`,
		':last-child': {
			borderBottom: 'none',
		},
	},
	ticketHolderEmail: {
		color: gray3,
		fontSize: 14,
	},
	paymentSection: {
		marginTop: 16,
		marginBottom: 16,
	},
	paymentSuccess: {
		fontSize: 16,
		fontWeight: 600,
		margin: 0,
	},
	receiptLink: {
		color: brandPrimary,
		textDecoration: 'underline',
		':hover': {
			textDecoration: 'none',
		},
	},
	emailNote: {
		marginTop: 16,
		marginBottom: 0,
	},
	ticketBreakdown: {
		marginBottom: 16,
		padding: 12,
		backgroundColor: '#f5f5f5',
		borderRadius: 4,
	},
	ticketBreakdownItem: {
		padding: '6px 0',
		fontSize: 15,
		':not(:last-child)': {
			borderBottom: `1px solid ${gray3}`,
		},
	},
	ticketPrice: {
		color: gray3,
		fontSize: 14,
	},
	ticketType: {
		color: gray3,
		fontSize: 14,
		fontWeight: 400,
	},
	ticketHolderListTitle: {
		fontSize: 15,
		fontWeight: 600,
		marginBottom: 8,
		marginTop: 12,
	},
});
